(function() {
	angular.module("app").directive("landing", landingController);

	function landingController() {
		return {templateUrl: "pages/landing/landing.html"};
	}
})();
